import React, { useState } from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, LogOut, Folder, MessageSquare, Menu, X, ArrowLeft, Palette, Briefcase } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../redux/slice/auth.slice';

const AdminLayout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const userId = localStorage.getItem('userId');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleLogout = () => {
        dispatch(logoutUser(userId)).then(() => {
            navigate('/login');
        });
    };

    const navItems = [
        { path: '/projects', label: 'Projects', icon: LayoutDashboard },
        { path: '/categories', label: 'Categories', icon: Folder },
        { path: '/inquiries', label: 'Inquiries', icon: MessageSquare },
        { path: '/careers', label: 'Careers', icon: Briefcase },
        // { path: '/theme', label: 'Theme Settings', icon: Palette },
    ];

    const isActive = (path) => location.pathname.startsWith(path);

    return (
        <div className="flex h-screen bg-surface overflow-hidden relative">
            {/* Mobile Header */}
            <div className="lg:hidden absolute top-0 left-0 right-0 h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 z-20">
                <button onClick={() => setIsSidebarOpen(true)} className="p-2 text-gray-600">
                    <Menu className="w-6 h-6" />
                </button>
                <span className="font-serif font-bold text-primary text-lg">Admin Panel</span>
                <div className="w-10"></div> {/* Spacer for centering */}
            </div>

            {/* Sidebar Overlay */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-30 lg:hidden"
                    onClick={() => setIsSidebarOpen(false)}
                />
            )}

            {/* Sidebar */}
            <div className={`
                fixed lg:static inset-y-0 left-0 z-40 w-64 bg-primary text-white shadow-xl transform transition-transform duration-300 ease-in-out
                ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 flex flex-col
            `}>
                <div className="p-6 flex items-center justify-between">
                    <h1 className="text-2xl font-serif font-bold text-white tracking-wide">
                        VALLETTA <span className="text-secondary text-sm block tracking-widest font-sans font-normal">ADMIN</span>
                    </h1>
                    <button onClick={() => setIsSidebarOpen(false)} className="lg:hidden text-gray-400 hover:text-white">
                        <X className="w-6 h-6" />
                    </button>
                </div>

                <nav className="mt-6 flex-1 px-4 space-y-2">
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            onClick={() => setIsSidebarOpen(false)}
                            className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 group ${isActive(item.path)
                                ? 'bg-secondary text-white shadow-lg shadow-secondary/20 font-medium'
                                : 'text-gray-400 hover:bg-white/5 hover:text-white'
                                }`}
                        >
                            <item.icon className={`w-5 h-5 mr-3 transition-colors ${isActive(item.path) ? 'text-white' : 'text-gray-500 group-hover:text-white'}`} />
                            {item.label}
                        </Link>
                    ))}
                </nav>

                <div className="p-6 border-t border-white/5 bg-black/20">
                    <button
                        onClick={handleLogout}
                        className="flex items-center w-full px-4 py-3 text-red-400 hover:bg-red-500/10 hover:text-red-300 rounded-lg transition-colors group"
                    >
                        <LogOut className="w-5 h-5 mr-3 group-hover:-translate-x-1 transition-transform" />
                        <span className="font-medium text-sm">Sign Out</span>
                    </button>
                </div>
            </div>

            {/* Main Content */}
            <div className="flex-1 overflow-auto bg-gray-50 pt-16 lg:pt-0 w-full relative">
                <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto min-h-full">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default AdminLayout;
